import moment from "moment";
import { POPPER_MODIFIER_TOP_BOTTOM_FLIP } from "@certa/common/constants";
import { PopperPlacements } from "@certa/catalyst/components/types";

import { DatePicker } from "@certa/catalyst/components/DatePicker";
import { useFilterOverlay } from "../FilterOverlay/FilterOverlayContext";

const DateFilter = () => {
  const { label, searchValue, setSearchValue } = useFilterOverlay();

  return (
    <DatePicker
      aria-label={label}
      value={searchValue ? moment(searchValue) : undefined}
      onChange={(_, valueString) => setSearchValue(valueString)}
      placeholder={`Search By ${label}...`}
      placement={PopperPlacements.AUTO}
      popperModifiers={POPPER_MODIFIER_TOP_BOTTOM_FLIP}
    />
  );
};

export { DateFilter };
